import { ProgramSessionSetControllerApi, SetControllerApi, SetTransitControllerApi } from "src/api/api";

export interface IWorkoutSessionSetTransitApiClients {
    setTransitControllerApi: SetTransitControllerApi;
}

export class WorkoutSessionSetTransitApiClients {
    private static instance: IWorkoutSessionSetTransitApiClients;

    private constructor() { }

    static getInstance(basePath: string): IWorkoutSessionSetTransitApiClients {
        if (WorkoutSessionSetTransitApiClients.instance == null) {
            WorkoutSessionSetTransitApiClients.instance = {
                setTransitControllerApi: new SetTransitControllerApi({
                    basePath: basePath,
                    isJsonMime() {
                        return true;
                    }
                }),
            };
        }
        return WorkoutSessionSetTransitApiClients.instance;
    }
}